import { compose, filter, groupBy, map, set, size, startsWith } from 'lodash/fp';
import replacement from '../../../services/Replacement';

const applyReplacement = link =>
    startsWith('REPLACEMENT', link.nameType) ? set('name', replacement(link.name), link) : link;

const appendCycleSuffix = link =>
    link.nameType === 'REPLACEMENT_PLUS_CYCLE' && link.name.indexOf(' Cycles') === -1
        ? set('name', `${link.name} Cycles`, link)
        : link;

export const groupLinksByCategory = links =>
    compose(
        groupBy('category'),
        map(appendCycleSuffix),
        map(applyReplacement),
        filter(link => link.visible)
    )(links);

export const countAdminErrors = links =>
    compose(
        size,
        filter(al => al.status === 'ERROR')
    )(links);
